
import { getProps } from '../props'
import create from '../Services/create'
import update from '../Services/update'

export default async (values, dispatch) => {

  const { onClose, didCreate, didUpdate } = getProps()

  if (!values.id) {

    const email = await dispatch(create(values))

    onClose()

    if (didCreate) didCreate(email)

  } else {

console.log('Vals',values);
    const email = await dispatch(update(values))

    onClose()
console.log("DidUpdate",didUpdate);
    if (didUpdate) didUpdate(email)

  }

}
